export default __webpack_public_path__ + "0cb16d9881999f9967075df035b07a14.svg";